(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('TypeService', TypeService);

    TypeService.$inject = ['$resource'];

    function TypeService ($resource) {
        var resourceUrl =  'api/type-services/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
